import React from 'react';

export const CengageLogo = () => (
  <svg viewBox="0 0 265 61" height="40">
    <defs>
      <path id="a" d="M24.391 49.537H.084V.097H24.39z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(0 11.342)">
        <path
          d="M13.548.211l9.139 3.152-1.46 7.449-12.67-4.367 3.116-5.48c.463-.813 1.078-1.029 1.875-.754"
          fill="#002D4B"
          mask="url(#b)"
        />
        <path
          d="M.63 23.752l7.978-7.116 6.182 5.512-11.063 9.868-3.42-6.032c-.51-.895-.374-1.61.323-2.232"
          fill="#005176"
          mask="url(#b)"
        />
        <path
          d="M14.945 48.077l-2.28-11.64 8.562-2.953 3.164 16.138h-7.534c-1.12 0-1.714-.529-1.912-1.545"
          fill="#008FC6"
          mask="url(#b)"
        />
      </g>
      <path
        d="M44.323 58.937L32.16 54.743l1.944-9.917 16.862 5.813-4.146 7.294c-.617 1.083-1.432 1.371-2.497 1.004"
        fill="#00ACDC"
      />
      <path
        d="M59.386 31.354l-10.619 9.472-8.226-7.335 14.724-13.135 4.554 8.03c.676 1.19.495 2.14-.433 2.968"
        fill="#6BC7E4"
      />
      <path
        d="M42.467 2.73l3.036 15.494-11.399 3.93L29.892.674h10.03c1.486 0 2.28.704 2.545 2.057"
        fill="#89D0E9"
      />
      <path
        d="M97.788 45.183c-3.018 1.626-5.99 2.23-8.779 2.23-9.279 0-14.674-6.46-14.674-15.427 0-8.875 6.127-15.938 15.268-15.938 3.246 0 5.99.743 7.59 1.626v3.856c-2.149-1.16-4.48-1.952-7.497-1.952-6.95 0-11.064 5.392-11.064 12.221 0 7.11 4.161 12.083 10.789 12.083 2.835 0 5.12-.837 7.223-1.998l1.144 3.3M104.683 16.326h15.224l-1.19 3.392h-9.965v9.851h9.829v3.44h-9.83v10.548h11.339v3.391h-15.407V16.326M126.804 16.326h3.932l13.622 18.03a92.979 92.979 0 0 1 4.069 5.715h.09c-.09-1.672-.09-3.16-.09-5.344V16.326h4.068v30.622h-3.566l-14.125-18.726a137.394 137.394 0 0 1-3.976-5.53h-.092c.092 1.441.136 2.929.136 5.112v19.144h-4.068V16.326M172.465 34.496l-1.19-3.393h12.526v13.941c-2.241 1.161-6.033 2.37-10.194 2.37-9.28 0-15.177-6.367-15.177-15.289 0-9.387 6.354-16.077 15.91-16.077 3.472 0 6.444.835 8.365 1.626v3.856a17.743 17.743 0 0 0-8.138-1.952c-7.59 0-11.839 5.019-11.839 12.176 0 7.435 4.342 12.128 11.29 12.128 2.331 0 4.434-.464 5.76-1.115v-8.271h-7.313M205.919 35.517l-2.834-7.992c-.87-2.602-1.325-3.996-1.692-5.111h-.09c-.321 1.115-.824 2.556-1.737 5.157l-2.836 7.946h9.189zm-6.034-19.285h2.88l11.702 30.716h-4.342l-2.972-8.039h-11.656l-2.881 8.04h-4.251l11.52-30.717zM230.553 34.496l-1.187-3.393h12.525v13.941c-2.24 1.161-6.034 2.37-10.193 2.37-9.282 0-15.178-6.367-15.178-15.289 0-9.387 6.355-16.077 15.909-16.077 3.473 0 6.445.835 8.364 1.626v3.856a17.727 17.727 0 0 0-8.137-1.952c-7.587 0-11.838 5.019-11.838 12.176 0 7.435 4.341 12.128 11.291 12.128 2.33 0 4.433-.464 5.76-1.115v-8.271h-7.316M249.199 16.326h15.224l-1.19 3.392h-9.966v9.851h9.828v3.44h-9.828v10.548h11.337v3.391h-15.405V16.326"
        fill="#002D4B"
      />
    </g>
  </svg>
);
